module.exports = [
  'Helvetica',
  'Times New Roman',
  'Palatino Linotype',
  'Gentium Basic',
  'Playfair Display',
  'Cardo',
  'Libre Baskerville',
  'Crimson Text',
  'Libre Franklin',
  'Lato',
  'Alegreya Sans',
  'Open Sans',
  'Source Sans Pro'
];


// WEBPACK FOOTER //
// ./resources/assets/js/settings/documentFontOptions.js